const ENGAGEMENT_KEY = 'garden-engagement-count';
const NUDGE_DISMISSED_KEY = 'garden-nudge-dismissed-at';
const NUDGE_COOLDOWN_MS = 3 * 24 * 60 * 60 * 1000; // 3 days

export function recordEngagement(): void {
  if (typeof window === 'undefined') return;
  try {
    const current = parseInt(localStorage.getItem(ENGAGEMENT_KEY) ?? '0', 10);
    localStorage.setItem(ENGAGEMENT_KEY, String(current + 1));
  } catch { /* quota — fail silently */ }
}

export function shouldShowEngagementNudge(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const count = parseInt(localStorage.getItem(ENGAGEMENT_KEY) ?? '0', 10);
    const dismissedAt = parseInt(localStorage.getItem(NUDGE_DISMISSED_KEY) ?? '0', 10);
    return count >= 3 && Date.now() - dismissedAt > NUDGE_COOLDOWN_MS;
  } catch { return false; }
}

export function dismissEngagementNudge(): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(NUDGE_DISMISSED_KEY, String(Date.now()));
  } catch { /* quota — fail silently */ }
}
